module.exports = __webpack_public_path__ + "assets/img/role-99effc39.png";